import {Form, Select} from 'antd';

import {StoreRuleAppType, StoreRulesCatalogType} from '../../../provider/catalogs/catalogs-type';
import {Locale} from '../../../provider/locale/locale';
import {LangKeyType} from '../../../provider/locale/translation/type';
import {FormInstance} from '../../../typings/antd';

import {AutoReplyFormFieldNameEnum} from './auto-reply-form-const';

const {Option} = Select;

type PropsType = {
    form: FormInstance<Record<string, unknown>>;
    getLocalizedString: (stringKey: LangKeyType) => string;
    storeApps: Array<StoreRuleAppType>;
    storeAppsIsInProgress: boolean;
    storeCatalogs: Array<StoreRulesCatalogType>;
    storeCatalogsIsInProgress: boolean;
};

export function AutoReplyFormFiltersStore(props: PropsType): JSX.Element {
    const {form, getLocalizedString, storeApps, storeAppsIsInProgress, storeCatalogs, storeCatalogsIsInProgress} =
        props;

    return (
        <>
            <Form.Item
                label={<Locale stringKey="AUTO_REPLIES__FORM__FEEDBACK_SOURCE" />}
                name={AutoReplyFormFieldNameEnum.StoreCatalog}
                rules={[{required: true, message: getLocalizedString('VALIDATION__ERROR__FIELD_IS_REQUIRED')}]}
            >
                <Select<number>
                    loading={storeCatalogsIsInProgress}
                    onChange={() => {
                        form.setFieldValue(AutoReplyFormFieldNameEnum.BrandCatalogCompany, null);
                    }}
                    placeholder={getLocalizedString('AUTO_REPLIES__FORM__SELECT_SOURCES')}
                    showSearch={false}
                    size="large"
                >
                    {storeCatalogs.map((catalog) => (
                        <Option key={catalog.id} value={catalog.id}>
                            {catalog.website}
                        </Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item
                label={<Locale stringKey="AUTO_REPLIES__FORM__APPLICATIONS" />}
                name={AutoReplyFormFieldNameEnum.BrandCatalogCompany}
                rules={[{required: true, message: getLocalizedString('VALIDATION__ERROR__FIELD_IS_REQUIRED')}]}
            >
                <Select<number>
                    loading={storeAppsIsInProgress}
                    placeholder={getLocalizedString('AUTO_REPLIES__FORM__SELECT_APPLICATIONS')}
                    showSearch={false}
                    size="large"
                >
                    {storeApps.map((app) => (
                        <Option key={app.id} value={app.id}>
                            {app.appName || app.appId || app.id}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
        </>
    );
}
